<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">{{ $t('Users Login Status') }}</h4>
        </div>
        <div class="px-4 py-3 border-b flex items-center space-x-3">
            <span class="text-sm font-medium">Filter by Last Login</span>
            <a-select
                :disabled="loading"
                v-model="recencyFilter"
                style="width: 260px"
                @change="handleChange"
            >
                <a-select-option value="today">
                    Logged in Today
                </a-select-option>
                <a-select-option value="thisWeek">
                    Logged in Yesterday - 1 Week
                </a-select-option>
                <a-select-option value="1week-1month">
                    Logged in 1 Week - 1 Month
                </a-select-option>
                <a-select-option value="1month-3month">
                    Logged in 1 Month - 3 Month
                </a-select-option>
                <a-select-option value="3month-6month">
                    Logged in 3 Month - 6 Month
                </a-select-option>
                <a-select-option value="6months-beyond">
                    Logged in Beyond 6 months
                </a-select-option>
                <a-select-option value="never">
                    No Login
                </a-select-option>
            </a-select>
            <div v-if="users.length">( Total: {{ users.length }} )</div>
        </div>
        <ul class="space-y-1">
            <li v-for="user in users" :key="user.id">
                <UserCard :user="user" />
            </li>
        </ul>
        <spinner v-if="loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../lib/api'
import { subDays, addDays } from 'date-fns'
import UserCard from '../components/InactiveUserCard'

const datesMap = {
    'today': d => [d, addDays(d, 1)],
    'thisWeek': d => [subDays(d, 7), d],
    '1week-1month': d => [subDays(d, 30), subDays(d, 7)],
    '1month-3month': d => [subDays(d, 90), subDays(d, 39)],
    '3month-6month': d => [subDays(d, 180), subDays(d, 90)],
    '6months-beyond': d => [null, subDays(d, 180)],
}
const getDates = filter => {
    let loginStartDate
    let loginEndDate
    if (!['never', 'all'].includes(filter)) {
        const now = new Date()
        ;[loginStartDate, loginEndDate] = datesMap[filter](now)
        if (loginStartDate) {
            loginStartDate = loginStartDate.toISOString().split('T')[0]
        }
        if (loginEndDate) {
            loginEndDate = loginEndDate.toISOString().split('T')[0]
        }
    }
    return [loginStartDate, loginEndDate]
}
export default {
    components: {
        UserCard,
    },
    data() {
        return {
            recencyFilter: 'today',
            users: [],
            loading: true,
            loadingMore: false,
            limit: 50,
            offset: null,
            hasMore: true,
        }
    },
    async mounted() {
        const [loginStartDate, loginEndDate] = getDates(this.recencyFilter)
        const [users, newOffset] = await api.getUsers(
            {
                inactiveUsers: true,
                limit: this.limit,
                loginStartDate,
                loginEndDate,
                recencyFilter: this.recencyFilter,
            },
            'lastLoginAt',
        )
        this.users = users
        this.offset = newOffset
        this.loading = false
        this.hasMore = users.length >= this.limit
    },
    methods: {
        async searchUsers() {
            this.loading = true
            this.users = []
            this.offset = null

            const [loginStartDate, loginEndDate] = getDates(this.recencyFilter)

            const [users, newOffset] = await api.getUsers(
                {
                    inactiveUsers: true,
                    limit: this.limit,
                    loginStartDate,
                    loginEndDate,
                    recencyFilter: this.recencyFilter,
                },
                'lastLoginAt',
            )
            this.users = users
            this.offset = newOffset
            this.loading = false
            if (this.recencyFilter === 'all') {
                this.hasMore = users.length >= this.limit
            } else {
                this.hasMore = false
            }
        },
        handleChange() {
            this.searchUsers()
        },
        async showMore() {
            this.loadingMore = true
            const [moreUsers, newOffset] = await api.getUsers(
                {
                    inactiveUsers: true,
                    limit: this.limit,
                    offset: this.offset,
                },
                'lastLoginAt',
            )
            this.hasMore = moreUsers.length >= this.limit
            this.users = [...this.users, ...moreUsers]
            this.offset = newOffset
            this.loadingMore = false
        },
    },
}
</script>
